import { render, staticRenderFns } from "./noPermit.vue?vue&type=template&id=d08582b4&"
import script from "./noPermit.vue?vue&type=script&lang=js&"
export * from "./noPermit.vue?vue&type=script&lang=js&"
import style0 from "./noPermit.vue?vue&type=style&index=0&id=d08582b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports